import { render, staticRenderFns } from "./BancoSelect.vue?vue&type=template&id=0efa5b48"
import script from "./BancoSelect.vue?vue&type=script&lang=js"
export * from "./BancoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports